<div class="favorites-section">
    <app-subpage-header
        #favoritesHeaderRef
        [title]="title"
        [subtitle]="(favorites$ | async)?.length ? '(' + (favorites$ | async)?.length + ')' : '(0)'"
        size="small"></app-subpage-header>

    <ng-container *ngIf="isLoaded$ | async; else loading">
        <ng-container *ngIf="favorites$ | async as favorites">
            <ng-container *ngIf="favorites?.length > 0; else noFavorites">
                <ul>
                    <li *ngFor="let favorite of favorites | slice: 0 : length; trackBy: trackByItem">
                        <app-favorite-button
                            [favoriteId]="favorite.favoriteId"
                            [onlyRemove]="true"></app-favorite-button>
                        <a
                            *ngIf="favorite.fragment; else path"
                            class="mat-mdc-menu-item-text"
                            [fragment]="favorite.fragment"
                            [routerLink]="'/' + favorite.routerLink"
                            [queryParams]="{ product: favorite.productId }"
                            [matTooltip]="'Visit ' + getLabel(favorite)"
                            [matTooltipShowDelay]="1000"
                            [matTooltipHideDelay]="2000">
                            {{ getLabel(favorite) }}
                        </a>
                        <ng-template #path>
                            <a
                                class="mat-mdc-menu-item-text"
                                [routerLink]="'/' + favorite.routerLink"
                                [queryParams]="{ product: favorite.productId }"
                                [matTooltip]="'Visit ' + getLabel(favorite)"
                                [matTooltipShowDelay]="1000"
                                [matTooltipHideDelay]="2000">
                                {{ getLabel(favorite) }}
                            </a>
                        </ng-template>
                    </li>
                </ul>
                <app-load-more-button
                    [length]="length"
                    [max]="max"
                    [modifier]="modifier"
                    [disabled]="isLoadMoreDisabled"
                    [headerRef]="favoritesHeaderRef"
                    (refreshLengthFn)="refreshLength($event)"></app-load-more-button>
            </ng-container>
        </ng-container>
    </ng-container>

    <ng-template #noFavorites>
        <p class="no-favorites">
            <b>You have not added anything to your favorites yet!</b><br />
            Adding favorites allows you to jump straight to the sections<br />
            of the Genesys Orchestrators site that matter most to you.<br />
            Start favoriting content now by clicking the
            <mat-icon [svgIcon]="'star-outline'" aria-hidden></mat-icon> wherever you <br />
            see the action menu <mat-icon [svgIcon]="'more_menu'"></mat-icon> on the site.
        </p>
    </ng-template>

    <ng-template #loading>
        <ul class="loading">
            <li *ngFor="let l of loadingArray">
                <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
            </li>
        </ul>
        <app-load-more-button [disabled]="true"></app-load-more-button>
    </ng-template>
</div>
